<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="pageLoading" class="loader text-center">
	<img src="../assets/img/loading.gif" />
</div>
<div class="card" *ngIf="UserModuleAccess=='Full'">
	<div class="card-header bg-theme">
		{{pagetitle}}
	</div>
	<div class="card-body">
		<form class="form-horizontal" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
			<div class="row mb-2">
				<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('name')}" id="name"
							formControlName="name" placeholder="Name*">
						<label for="name">Name*</label>
					</div>
					<p *ngIf="showError('name')" class="text-danger">
						<span *ngIf="f.name.errors?.required">
							Required
						</span>
						<span *ngIf="f.name.errors?.incorrect">
							{{customError.name}}
						</span>
					</p>
				</div>
				<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('description')}" id="description"
							formControlName="description" placeholder="Description*">
						<label for="description">Description*</label>
					</div>
					<p *ngIf="showError('description')" class="text-danger">
						<span *ngIf="f.description.errors?.required">
							Required
						</span>
						<span *ngIf="f.description.errors?.incorrect">
							{{customError.description}}
						</span>
					</p>
				</div>
				<!-- <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
					<label>Age Limit*:</label>
					<br />
					<mat-radio-group aria-label="Select an option" formControlName="age">
						<mat-radio-button [name]="'age'" ngDefaultControl [value]="0" [color]="'primary'">
							Above 18
						</mat-radio-button>
						<mat-radio-button [name]="'age'" ngDefaultControl [value]="1" [color]="'primary'">
							Below 18
						</mat-radio-button>
					</mat-radio-group>
					<p *ngIf="showError('age')" class="text-danger">
						<span *ngIf="f.age.errors?.required">
							Required
						</span>
						<span *ngIf="f.age.errors?.incorrect">
							{{customError.age}}
						</span>
					</p>
				</div> -->
			</div>
			<div class="row mb-2">
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
					<ng-select id="scale" [items]="scaleList" bindLabel="scale_name" bindValue="id" [clearable]="true"
						placeholder="Scale" formControlName="scale" [multiple]="true" appearance="outline"
						[ngClass]="{'is-invalid':showError('scale')}">
					</ng-select>
					<p *ngIf="showError('scale')" class="text-danger">
						<span *ngIf="f.scale.errors?.required">
							Required
						</span>
						<span *ngIf="f.scale.errors?.incorrect">
							{{customError.scale}}
						</span>
					</p>
				</div>
			</div>
			<div class="row mb-2">
				<div class="col text-center">
					<button type="submit" [disabled]="showLoader || !modform.dirty"
						class="btn btn-sm btn-outline-success">
						<span class="me-1">
							<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
							<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
						</span>
						<span>Save</span>
					</button>
					<a class="btn btn-sm btn-outline-dark ms-1" [routerLink]="['/app/profile-list']">Cancel</a>
				</div>
			</div>
		</form>
	</div>
</div>
<div *ngIf="UserModuleAccess!='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>